
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Creates a new unposted position profile for an opening.`}</p>
    <p>{`If the position opening already contains 25 position profiles this will fail with a `}<inlineCode parentName="p">{`BAD_USER_INPUT`}</inlineCode>{` error.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;